var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-status-cell",attrs:{"title":_vm.title}},[(!_vm.meta.isEmpty)?_c('span',{staticClass:"product-status-dot",class:'product-status-dot--' + _vm.meta.color}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }